import { map } from 'lodash';
import axios from 'axios';

import Api from 'client/api/v2/Api';
import PushEndpoint from 'client/store/modules/push/models';

export class SystemUserPushApi extends Api {
  constructor() {
    super();
    this.baseUrl = '/api/v2/users';
  }

  async getDeviceEndpoints(id) {
    await this.initialize();

    const response = await axios.get(`${this.baseUrl}/${id}/pushendpoints`);

    return map(response.data, endpoint => PushEndpoint.fromApi(endpoint));
  }

  async deleteDeviceEndpoint(userId, endpointId) {
    await this.initialize();

    const response = await axios.delete(`${this.baseUrl}/${userId}/pushendpoints/${endpointId}`);

    return response.data;
  }
}

export default new SystemUserPushApi();
